/**
* @file 业务设置-基础设置
* */
<template>
  <div id="ticketing">
    <el-form :model="form" :rules="rules" ref="form" label-width="110px" label-position="left">
      <div class="blueInfo" style="width: 730px">
        <p>
          *
          子机构获【票务管理】权限后，可独立设置以下配置项，与主机构配置的内容互不影响
        </p>
        <p>* 如子机构未获得本权限，则以下配置项内容由主机构统一管理</p>
      </div>

      <el-form-item label="售票截止时限" prop="ticketDeadline">
        <el-input v-model="form.ticketDeadline" placeholder="请设置时限" maxlength="3" style="width: 262px"
                  onkeyup="this.value=this.value.replace(/\D/g,'')"
                  onafterpaste="this.value=this.value.replace(/\D/g,'')">
        </el-input>
        <span style="padding-left: 5px"> 分钟</span>
        <p class="el-form-item-remark" style="line-height: 20px">
          假如设置为30分钟，则在检票或接人前30分钟，停止售票
        </p>
      </el-form-item>

      <el-form-item label="待支付时效" prop="orderPayTime">
        <el-input style="width: 262px" v-model="form.orderPayTime" maxlength="3"
                  onkeyup="this.value=this.value.replace(/\D/g,'')"
                  onafterpaste="this.value=this.value.replace(/\D/g,'')"
                  placeholder="请输入待支付时效"></el-input>
        <span style="padding-left: 5px"> 分钟</span>
        <p class="el-form-item-remark">未完成支付订单，自动销单的时间</p>
      </el-form-item>

      <!-- <el-form-item label="班线报班售票" prop="stationRegister">
        <el-radio-group v-model="form.stationRegister">
          <el-radio :label="1" :value="1">报班后才能售票 </el-radio>
          <el-radio :label="2" :value="2">不报班也能售票 </el-radio>
        </el-radio-group>
      </el-form-item> -->

      <el-form-item label="扫码下单补票">
        <div>
          <el-switch v-model="form.fastOrderTicket" :active-value="1" :inactive-value="2"></el-switch>
          <span class="el-form-item-remark"
                style="display: inline-block; padding-left: 8px">已过检票/接人时间的班次，可通过乘客端扫码下单补票</span>
        </div>
      </el-form-item>

      <el-form-item label="退票规则">
        <div>
          <el-switch v-model="form.refundRules" :active-value="1" :inactive-value="2"></el-switch>
          <span class="el-form-item-remark"
                style="display: inline-block; padding-left: 8px">如关闭退票规则，则乘客退票不收取退票费</span>
        </div>
        <p class="attention">
          用了优惠券的订单，将按使用后的实际支付金额，来计算退票费
        </p>
      </el-form-item>
      <div class="el-form-item-line" v-for="(row, index) in form.refundRulesJson" :key="index">
        <el-form-item label="">
          <span>检票/接人时间</span>
        </el-form-item>

        <el-form-item label="" :prop="'refundRulesJson.' + index + '.timeNum'" :rules="form.refundRules === 1
          ? [
            { required: true, message: '请输入数字' },
            { pattern: /^[1-9]\d*?$/, message: '请输入正确的数字' },
            { validator: validateTimeNum, trigger: 'change' },
          ]
          : []
          ">
          <el-input v-model="row.timeNum" maxlength="2"></el-input>
        </el-form-item>

        <el-form-item label="">
          <el-select v-model="row.timeType">
            <el-option label="小时" :value="1"></el-option>
            <el-option label="分钟" :value="2"></el-option>
          </el-select>
          <span>内办理退票的，</span>
          <span>按支付金额</span>
        </el-form-item>

        <el-form-item :prop="'refundRulesJson.' + index + '.refundFee'" :rules="form.refundRules === 1
          ? [
            { required: true, message: '请输入数字' },
            {
              pattern: /^([1-9]\d?|100)$/,
              message: '请输入正确的数值(1-100)',
            },
          ]
          : []
          ">
          <el-input v-model="row.refundFee" maxlength="3"></el-input>
          <span>%收取退票费</span>
        </el-form-item>
        <el-tooltip content="删除" placement="top">
          <i v-if="index !== 0" class="iconfont icon-delete" @click="removeClick('refundRulesJson', index)"></i>
        </el-tooltip>
      </div>
      <div class="add" @click="addClick('refundRulesJson')" v-if="form.refundRulesJson.length < 5">
        <i class="el-icon-plus"></i>添加规则
      </div>

      <el-form-item label="改签规则">
        <div>
          <el-switch v-model="form.ticketChangingRules" :active-value="1" :inactive-value="2"></el-switch>
          <span class="el-form-item-remark"
                style="display: inline-block; padding-left: 8px">如关闭改签规则，则乘客改签不收取改签费</span>
        </div>
        <p class="attention">
          用了优惠券的订单，将按使用后的实际支付金额，来计算改签费
        </p>
      </el-form-item>
      <div class="el-form-item-line" v-for="(row, index) in form.ticketChangingRulesJson" :key="index + 'x'">
        <el-form-item label="">
          <span>检票/接人时间</span>
        </el-form-item>
        <el-form-item label="" :prop="'ticketChangingRulesJson.' + index + '.timeNum'" :rules="form.ticketChangingRules === 1
          ? [
            { required: true, message: '请输入数字' },
            { pattern: /^[1-9]\d*?$/, message: '请输入正确的数字' },
            { validator: validateChangeTimeNum, trigger: 'change' },
          ]
          : []
          ">
          <el-input v-model="row.timeNum" maxlength="2"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-select v-model="row.timeType">
            <el-option label="小时" :value="1"></el-option>
            <el-option label="分钟" :value="2"></el-option>
          </el-select>
          <span>内办理改签的，</span>
          <span>按支付金额</span>
        </el-form-item>
        <el-form-item :prop="'ticketChangingRulesJson.' + index + '.ticketChangingProportion'
          " :rules="form.ticketChangingRules === 1
            ? [
              { required: true, message: '请输入数字' },
              { pattern: /^[1-9]\d*?$/, message: '请输入正确的数字' },
            ]
            : []
            ">
          <el-input v-model="row.ticketChangingProportion" v-input-filter="{ min: 1, max: 100, precision: 0 }">
          </el-input>
          <span>%收取改签费</span>
        </el-form-item>
        <el-tooltip content="删除" placement="top">
          <i v-if="index !== 0" class="iconfont icon-delete" @click="removeClick('ticketChangingRulesJson', index)"></i>
        </el-tooltip>
      </div>
      <div class="add" @click="addClick('ticketChangingRulesJson')" v-if="form.ticketChangingRulesJson.length < 5">
        <i class="el-icon-plus"></i>添加规则
      </div>

      <template v-if="mixinUserInfo.platformType == 1">
        <el-form-item label="商品退款规则">
          <div>
            <el-switch v-model="form.travelRefundRules" :active-value="1" :inactive-value="2"></el-switch>
            <span class="el-form-item-remark"
                  style="display: inline-block; padding-left: 8px">如关闭退款规则，文旅商品订单退款不产生手续费</span>
          </div>
        </el-form-item>
        <div class="el-form-item-line" v-for="(row, index) in form.travelRefundRulesJson" :key="index + '_travel'">
          <el-form-item label="">
            <span>预约出行日期</span>
          </el-form-item>

          <el-form-item label="" :prop="'travelRefundRulesJson.' + index + '.timeNum'" :rules="form.travelRefundRules === 1
            ? [
              { required: true, message: '请输入数字' },
              { pattern: /^[1-9]\d*?$/, message: '请输入正确的数字' },
              { validator: validateTravelTimeNum, trigger: 'change' },
            ]
            : []
            ">
            <el-input v-model="row.timeNum" v-input-filter="{ min: 1, max: 9999, precision: 0 }"></el-input>
          </el-form-item>

          <el-form-item label="">
            <el-select v-model="row.timeType">
              <el-option label="天" :value="1"></el-option>
              <!-- <el-option label="小时" :value="2"></el-option> -->
            </el-select>
            <span>内申请退款的，按支付金额</span>
          </el-form-item>

          <el-form-item :prop="'travelRefundRulesJson.' + index + '.proportion'" :rules="form.travelRefundRules === 1
            ? [
              { required: true, message: '请输入数字' },
              {
                pattern: /^([1-9]\d?|100)$/,
                message: '请输入正确的数值(1-100)',
              },
            ]
            : []
            ">
            <el-input v-model="row.proportion" maxlength="3"
                      v-input-filter="{ min: 1, max: 100, precision: 0 }"></el-input>
            <span>%收取手续费</span>
          </el-form-item>
          <el-tooltip content="删除" placement="top">
            <i v-if="index !== 0" class="iconfont icon-delete" @click="removeClick('travelRefundRulesJson', index)"></i>
          </el-tooltip>
        </div>
        <div class="add" @click="addClick('travelRefundRulesJson')" v-if="form.travelRefundRulesJson.length < 5">
          <i class="el-icon-plus"></i>添加规则
        </div>

        <el-form-item label="三方退票规则">
          <div>
            <el-switch v-model="form.thirdRefundRules" :active-value="1" :inactive-value="2"></el-switch>
            <span class="el-form-item-remark"
                  style="display: inline-block; padding-left: 8px">如关闭退票规则，则三方订单退票不收取退票费（目前只支持出行365订单）</span>
          </div>
          <p class="attention">
            用了优惠券的订单，将按使用后的实际支付金额，来计算退票费
          </p>
        </el-form-item>
        <div class="el-form-item-line" v-for="(row, index) in form.thirdRefundRulesJson" :key="index + '_third'">
          <el-form-item label="">
            <span>检票/接人时间</span>
          </el-form-item>

          <el-form-item label="">
            <el-input v-model="row.timeNum" v-input-filter="{ min: 0, max: 9999, precision: 0 }"></el-input>
          </el-form-item>

          <el-form-item label="">
            <el-select v-model="row.timeType">
              <el-option label="小时" :value="1"></el-option>
              <el-option label="分钟" :value="2"></el-option>
            </el-select>
            <span>内办理退票的，按支付金额</span>
          </el-form-item>

          <el-form-item>
            <el-input v-model="row.refundFee" maxlength="3"
                      v-input-filter="{ min: 0, max: 100, precision: 0 }"></el-input>
            <span>%收取退票费</span>
          </el-form-item>
          <el-tooltip content="删除" placement="top">
            <i v-if="index !== 0" class="iconfont icon-delete" @click="removeClick('thirdRefundRulesJson', index)"></i>
          </el-tooltip>
        </div>
        <div class="add" @click="addClick('thirdRefundRulesJson')" v-if="form.thirdRefundRulesJson.length < 5">
          <i class="el-icon-plus"></i>添加规则
        </div>
      </template>

      <template v-if="mixinUserInfo.platformType == 2">
        <el-form-item label="售票类型">

          <el-form-item label-width="0px">
            <div class="flex-start">
              <span style="margin-right: 10px;margin-bottom: 4px"> 站内售票员可售票类型</span>
              <el-checkbox-group v-model="form.stationTicketType">
                <el-checkbox :disabled="item.value == 1" v-for="item in $const.TICKETTYPE" :key="item.value"
                             :label="item.value">{{ item.label }}
                </el-checkbox>

              </el-checkbox-group>
            </div>
            <p class="util-remark">站内售票员，仅可售出已勾选了的售票类型</p>
          </el-form-item>

          <el-form-item label-width="0px">
            <div class="flex-start">
              <div style="margin-right: 10px;margin-bottom: 4px">推广售票员可售票类型</div>
              <el-checkbox-group v-model="form.mobileTicketType">
                <el-checkbox :disabled="item.value == 1" v-for="item in $const.TICKETTYPE" :key="item.value"
                             :label="item.value">{{ item.label }}
                </el-checkbox>

              </el-checkbox-group>
            </div>
            <p class="util-remark">推广售票员，仅可售出已勾选了的售票类型</p>
          </el-form-item>
        </el-form-item>

        <el-form-item label="网络售票">
          <div>
            <el-switch v-model="form.onlineTicketing" :active-value="1" :inactive-value="2"></el-switch>
            <span class="el-form-item-remark"
                  style="display: inline-block; padding-left: 8px">如关闭网络售票，则会停用小程序、极速购票、司机、联网售票、移动售票等网络售票渠道</span>
          </div>
        </el-form-item>
      </template>

      <el-form-item label="微信小程序退票"
                    v-if="mixinUserInfo.platformType === 2 || mixinUserInfo.platformType === 1">
        <div>
          <div>
            <el-form-item label-width="0" prop="travelOrderAssign">
              <el-switch v-model="form.appletRefund" :active-value="1" :inactive-value="2"></el-switch>
              <span class="el-form-item-remark" style="display: inline-block; padding-left: 8px">如关闭用户微信小程序退票功能，则用户在小程序上无法退票，用户如需退票只能到窗口找工作人员处理
            </span>
            </el-form-item>

          </div>
          <el-form-item prop="appletRefundCloseRemark">
            <div v-if="form.appletRefund == 2">
              <el-input maxlength="50" style="width: 300px" v-model="form.appletRefundCloseRemark">
              </el-input>
              <span class="el-form-item-remark" style=" padding-left: 8px">关闭说明。填写的内容将显示在小程序退票按钮上方
                 </span>
            </div>
          </el-form-item>
        </div>
      </el-form-item>


      <el-form-item style="padding: 10px 0 50px 0">
        <el-button type="primary" @click="saveClick" :loading="loading">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "ticketing",
  data() {
    return {
      // 表单

      form: {
        refundRulesJson: [
          {
            timeType: 1,
          },
        ],
        travelRefundRulesJson: [
          {
            timeType: 1,
          },
        ],
        thirdRefundRulesJson: [
          {
            timeType: 1,
          },
        ],
        ticketChangingRulesJson: [
          {
            timeType: 1,
          },
        ],
        stationTicketType: []
      },
      // 校验规则
      rules: {},
      // 保存按钮loading
      loading: false,
    };
  },
  methods: {
    calculateMinutes(item) {
      return item.timeType === 1
          ? Number(item.timeNum) * 60
          : Number(item.timeNum);
    },
    calculateMinutesTravel(item) {
      return item.timeType === 1
          ? Number(item.timeNum) * 24
          : Number(item.timeNum);
    },
    /**
     * 通用时间验证器
     * @param {Object} rule 验证规则
     * @param {String|Number} value 验证值
     * @param {Function} callback 回调函数
     * @param {String} listName 要验证的列表名称
     */
    validateTime(rule, value, callback, listName) {
      let arr = rule.fullField.split(".");
      let i = Number(arr[1]);

      // 根据列表类型选择不同的计算方法
      const calcMethod = listName === "travelRefundRulesJson" ?
          this.calculateMinutesTravel : this.calculateMinutes;

      let item = calcMethod(this.form[listName][i]);
      let prevItem =
          i > 0 ? calcMethod(this.form[listName][i - 1]) : null;
      let nextItem = this.form[listName][i + 1]
          ? calcMethod(this.form[listName][i + 1])
          : null;

      if (i > 0 && prevItem && item >= prevItem) {
        callback(new Error("请小于上一项规则的时间"));
      } else if (i < 5 && nextItem && item <= nextItem) {
        callback(new Error("请大于下一项规则的时间"));
      } else {
        callback();
      }
    },

    /**
     * 验证退票规则时间
     */
    validateTimeNum(rule, value, callback) {
      this.validateTime(rule, value, callback, "refundRulesJson");
    },

    /**
     * 验证改签规则时间
     */
    validateChangeTimeNum(rule, value, callback) {
      this.validateTime(rule, value, callback, "ticketChangingRulesJson");
    },

    /**
     * 验证文旅商品退款规则时间（如果需要的话）
     */
    validateTravelTimeNum(rule, value, callback) {
      this.validateTime(rule, value, callback, "travelRefundRulesJson");
    },


    removeClick(list, index) {
      this.form[list].splice(index, 1);
    },
    addClick(list) {
      this.form[list].push({
        timeType: 1,
      });
    },
    /**
     * 点击保存
     */
    async saveClick() {
      console.log(this.form, 3223);
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.postFn();
        } else {
          this.$message.warning("请检查表单数据是否输入正确！");
          return false;
        }
      });
    },
    /**
     * 接口请求-提交配置
     */
    async postFn() {
      this.loading = true;
      let url =
          this.mixinUserInfo.organizationType === 1
              ? "/api/v1/manage/systems"
              : "/api/v1/manage/systems/ticket";
      let params = this.$utils.deepCopyFn(this.form);
      params.refundRulesJson = params.refundRulesJson
          ? JSON.stringify(params.refundRulesJson)
          : "";
      params.ticketChangingRulesJson = params.ticketChangingRulesJson
          ? JSON.stringify(params.ticketChangingRulesJson)
          : "";
      params.travelRefundRulesJson = params.travelRefundRulesJson
          ? JSON.stringify(params.travelRefundRulesJson)
          : "";
      params.thirdRefundRulesJson = params.thirdRefundRulesJson
          ? JSON.stringify(params.thirdRefundRulesJson)
          : "";
      // 校验三方退票规则
      if (this.form.thirdRefundRules === 1) {
        const hasValidRule = this.form.thirdRefundRulesJson.some(rule => 
          rule.timeNum && rule.refundFee
        );
        if (!hasValidRule) {
          this.$message.warning("三方退票规则已开启，请至少配置一条有效规则！");
          this.loading = false;
          return false;
        }
      }
      if (!this.form.orderPayTime) {
        this.$message.warning("请检查待支付时效是否输入正确！");
        this.loading = false;
        return false;
      }
      if (this.form.orderPayTime == 0) {
        this.$message.warning("待支付时效不能为0分钟");
        this.loading = false;
        return false;
      }
      let data = await this.$axios.put(url, {
        ...params, systemFlag: 3,
        stationTicketType: params.stationTicketType.toString(),
        mobileTicketType: params.mobileTicketType.toString(),
      });
      if (data && data.code === 1) {
        this.$message.closeAll();
        this.$message.success("保存成功！");
        this.driverInfo();
      }
      this.loading = false;
    },
    /**
     * 获取票务配置详情
     */
    async driverInfo() {
      let url =
          this.mixinUserInfo.organizationType === 1
              ? "/api/v1/manage/systems"
              : "/api/v1/manage/systems/ticket/" +
              this.mixinUserInfo.organizationId;
      let data = await this.$axios.get(url);
      if (data && data.code === 1) {
        data.data.refundRulesJson = data.data.refundRulesJson
            ? JSON.parse(data.data.refundRulesJson)
            : [{timeType: 1}];
        data.data.ticketChangingRulesJson = data.data.ticketChangingRulesJson
            ? JSON.parse(data.data.ticketChangingRulesJson)
            : [{timeType: 1}];
        data.data.travelRefundRulesJson = data.data.travelRefundRulesJson
            ? JSON.parse(data.data.travelRefundRulesJson)
            : [{timeType: 1}];
        data.data.thirdRefundRulesJson = data.data.thirdRefundRulesJson
            ? JSON.parse(data.data.thirdRefundRulesJson)
            : [{timeType: 1}];
        this.form = {
          ...this.form,
          ...data.data,
          stationTicketType: data.data.stationTicketType ? data.data.stationTicketType.split(",").map((item) => Number(item)) : [1],
          mobileTicketType: data.data.mobileTicketType ? data.data.mobileTicketType.split(",").map((item) => Number(item)) : [1]
        } || {};
        console.log('this.form', this.form);
      }
    },
  },
  created() {
    this.driverInfo();
  },
};
</script>

<style lang="less">
#ticketing {
  .el-form .el-select {
    width: auto !important;
  }

  .el-radio__label {
    font-size: 14px;
    font-weight: 600;
    color: #222222;
  }

  .el-radio-item + .el-radio-item {
    padding-top: 8px;
  }

  .el-radio-item .el-form-item-remark {
    padding-top: 8px;
  }

  .add {
    width: 650px;
    margin-left: 100px;
    margin-bottom: 18px;

    border: 1px #ebebeb dashed;
    line-height: 28px;
    text-align: center;
    cursor: pointer;

    &:hover {
      border-color: @color-primary;
      color: @color-primary;
    }
  }

  .el-form-item-line {
    display: flex;
    line-height: 28px;

    .el-form-item__error {
      white-space: nowrap;
    }

    .icon-delete {
      color: @color-danger;
      margin-left: 16px;
    }

    .el-form-item .el-form-item__content {
      font-size: 14px;
    }

    .el-form-item + .el-form-item {
      .el-form-item__content {
        margin-left: 0 !important;
      }
    }

    .el-input {
      width: 100px;
      margin: 0 4px;
    }
  }

  .attention {
    margin-top: 10px;
    background-color: #f2f2f2;
    width: 650px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    padding-left: 10px;
    box-sizing: border-box;
  }
}
</style>
